<template>
  <div class="news-card" @click="$emit('click')">
    <div class="news-card__title ellipsis-2">
      {{ item.title }}
    </div>
    <div class="news-card__meta">
      <span v-if="item.published_time" class="news-card__date">
        {{ item.published_time }}
      </span>
      <span class="news-card__read">
        浏览量：{{ item.browse_num }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/variable.scss";

.news-card {
  width: 100%;
  background-color: $color-bg-page;
  border-radius: 0;
  box-shadow: none;
  padding: $space-md;
  box-sizing: border-box;
  margin: 0 auto;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background-color: #f5f5f5;
  }

  &__title {
    font-size: $font-size-title-sm;
    font-weight: 600;
    color: $color-text-main;
    line-height: 1.5;
    margin-bottom: $space-sm;
  }

  &__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $font-size-caption;
    color: $color-text-sub;
  }

  &__date,
  &__source,
  &__read {
    white-space: nowrap;
  }
}
</style>


